<div class="relative inset-0 flex flex-1 flex-row">
  @if (!builderStatus.status().isPlaying) {
    <!-- @if (true) { -->
    <div class="w-15 z-99999 absolute h-full overflow-visible">
      <p-dock
        [model]="elementService.widgetList"
        cdkDropList
        [cdkDropListData]="elementService.widgetList"
        [cdkDropListConnectedTo]="dragDropService.subSectionList()"
        id="localElements"
        position="left"
        class="elementList"
      >
        <ng-template #item let-item>
          <div
            (mouseenter)="justIcon.dataset['hover'] = 'true'"
            (mouseleave)="justIcon.dataset['hover'] = 'false'"
            cdkDrag
            [cdkDragData]="item"
            class="draggingBox relative !overflow-visible p-2"
          >
            <div #justIcon class="flex">
              <mat-icon [svgIcon]="item.icon" class="cursor-pointer"></mat-icon>
            </div>

            @if (justIcon.dataset['hover'] === 'true') {
              <div
                class="absolute -left-1 overflow-visible"
                style="top: 50%; transform: translateY(-50%)"
              >
                <div
                  class="flex cursor-pointer flex-row rounded-2xl bg-white py-3 pl-2 pr-3 shadow-md"
                >
                  <mat-icon [svgIcon]="item.icon" class="ml-1"></mat-icon>
                  <div class="w-max justify-center self-center px-2">
                    {{ item.label }}
                  </div>
                </div>
              </div>
            }

            <div
              *cdkDragPreview
              class="flex cursor-pointer flex-row rounded-2xl bg-white py-3 pl-2 pr-3 shadow-md"
            >
              <mat-icon [svgIcon]="item.icon" class="ml-1"></mat-icon>
              <div class="w-max justify-center self-center px-2">
                {{ item.label }}
              </div>
            </div>

            <div *cdkDragPlaceholder class="placeholder w-full py-3">
              <div
                class="h-10 w-full rounded-md bg-gray-500 bg-opacity-15 outline-dotted outline-4 outline-offset-2 outline-gray-300"
              ></div>
            </div>
          </div>
        </ng-template>
      </p-dock>
    </div>

    <div class="mx-auto flex min-w-0 flex-auto flex-col items-center gap-4">
      <lib-module-builder class="block h-full w-full" />
    </div>
  } @else {
    <lib-playground class="mx-auto h-full w-full max-w-screen-lg" />
  }
</div>
